import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import { Box, styled, Typography } from '@mui/material';

// Device
export const StyledPageWrapper = styled(Box, {
  shouldForwardProp: (prop) => !['newMeasurmentDevice', 'setValue'].includes(prop as string),
})(({ newMeasurmentDevice = false }: { newMeasurmentDevice: boolean | undefined }) => {
  return {
    width: '47.125rem',
    padding: newMeasurmentDevice ? '0' : '1rem 0rem 2rem 0rem',
  };
});

export const StyledMeasurmentDeviceHeader = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    padding: ` 0 0 ${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24} 0`,
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_4,
  };
});

export const StyledSubtitleSection = styled(Typography)(() => {
  return {
    margin: 'auto 0',
    color: tsoPqTheme.palette.customTextColor.color_neutral_font_ft_nrtrl_enabled,
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: tsoPqTheme.typography.fontsize_body_body_medium,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '1.25rem',
    textDecoration: 'none',
    padding: ` 0 0 ${tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8} 0`,
  };
});

export const StyledTitleWrapper = styled(Box)(() => {
  return {
    display: 'flex',
    justifyContent: 'space-between',
  };
});

export const StyledTitleSection = styled(Box)(() => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '1.125rem',
  };
});

export const StyledVersionSection = styled(Box)(() => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '1.125rem',
  };
});

export const StyledTitle = styled(Typography)(() => {
  return {
    margin: 'auto 0',
    color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: tsoPqTheme.typography.fontsize_title_section_smaller,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '2.125rem',
  };
});

export const StyledFormWrapper = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xxs,
  };
});

export const StyledLineWrapper = styled(Box)(() => {
  return {
    display: 'flex',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xxs,
  };
});

export const StyledMeasurmentDeviceTitle = styled(Typography)(() => {
  return {
    color: tsoPqTheme.palette.customTextColor.color_font_ft_second_text,
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: tsoPqTheme.typography.fontsize_body_body_large,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '1.25rem',
  };
});

export const StyledMeasurmentDeviceValueLabel = styled(Typography)(() => {
  return {
    width: '10rem',
    color: tsoPqTheme.palette.customTextColor.color_font_ft_helping_text,
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: tsoPqTheme.typography.fontsize_body_body_medium,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '1rem',
  };
});

export const StyledMeasurmentDeviceValue = styled(Typography)(() => {
  return {
    width: '38.375rem',
    color: tsoPqTheme.palette.customTextColor.color_font_ft_helping_text,
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: tsoPqTheme.typography.fontsize_body_body_medium,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '1rem',
  };
});

export const StyledValuesWrapper = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.875rem',
  };
});

export const StyledMeasurmentDeviceHistoryContainer = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xxs,
    padding: `${tsoPqTheme.spacingValues.pageSpacing.spacing_page_margin_page_margin_xs} 0 0 0`,
  };
});

export const StyledDeviceInfo = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_12,
  };
});

export const StyledDeviceInfoLineWrapper = styled(Box)(() => {
  return {
    display: 'flex',

    '& > p:nth-of-type(odd)': {
      width: '6.25rem',
    },

    '& > p:nth-of-type(even)': {
      width: '6.25rem',
    },
  };
});

export const StyledDetail = styled(Typography)(() => {
  return {
    fontFamily: tsoPqTheme.typography.openSans,
    fontWeight: 400,
    fontSize: tsoPqTheme.typography.fontsize_body_body_small,
    lineHeight: tsoPqTheme.typography.lineHeight_s,
    color: tsoPqTheme.palette.customTextColor.color_font_ft_helping_text,
  };
});

//Point
export const StyledPageMeasurementWrapper = styled(Box, {
  shouldForwardProp: (prop) => !['newMeasurementPoint', 'setValue'].includes(prop as string),
})(({ newMeasurementPoint = false }: { newMeasurementPoint: boolean | undefined }) => {
  return {
    width: '47.125rem',
    padding: newMeasurementPoint ? '0' : '1rem 0rem 2rem 0rem',
  };
});

export const StyledHeader = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    padding: ` 0 0 ${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24} 0`,
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_4,
  };
});

export const StyledMeasurmentPointTitle = styled(Typography)(() => {
  return {
    margin: 'auto 0',
    color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: tsoPqTheme.typography.fontsize_title_section_smaller,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '2.125rem',
  };
});

export const StyledWrapper = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xxs,
  };
});

export const StyledMesurments = styled(Box)(() => {
  return {};
});

export const StyledMeasurmentTitle = styled(Typography)(() => {
  return {
    color: tsoPqTheme.palette.customTextColor.color_font_ft_second_text,
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: tsoPqTheme.typography.fontsize_body_body_large,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '1.25rem',
  };
});

export const StyledMeasurmentValueLabel = styled(Typography)(() => {
  return {
    width: '10rem',
    color: tsoPqTheme.palette.customTextColor.color_font_ft_helping_text,
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: tsoPqTheme.typography.fontsize_body_body_medium,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '1rem',
  };
});

export const StyledMeasurmentValue = styled(Typography)(() => {
  return {
    width: '38.375rem',
    color: tsoPqTheme.palette.customTextColor.color_font_ft_helping_text,
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: tsoPqTheme.typography.fontsize_body_body_medium,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '1rem',
  };
});

export const StyledMeasurmentHistoryContainer = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xxs,
    padding: `${tsoPqTheme.spacingValues.pageSpacing.spacing_page_margin_page_margin_xs} 0 0 0`,
  };
});

export const StyledCheckboxContainer = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_4,
  };
});

export const StyledCheckboxLineWrapper = styled(Box)(() => {
  return {
    display: 'flex',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_4,
    alignItems: 'anchor-center',
  };
});
